import { useEffect, useState } from "react";
import LinearProgress from "@mui/material/LinearProgress";

interface SplashPageProps {
  progress: number;
}

const SplashPage = ({ progress }: SplashPageProps) => {
  const [buffer, setBuffer] = useState(10);

  useEffect(() => {
    if (progress > buffer) {
      setBuffer(Math.min(progress + 10, 100));
    }
  }, [progress, buffer]);

  return (
    <div
      className={`h-[100vh] flex flex-col items-center justify-center lg:px-80 md:px-40 px-20 `}
    >
      <img
        src="https://cdn.greensoft.mn/uploads/site/1458/site_config/logo/3c541b215a75ef76d2d64d99c79283a04f48aace.png"
        alt="Бэлэн бай"
        className="h-10 w-auto"
      />
      <div className="w-full h-4 mt-8">
        <LinearProgress
          variant="buffer"
          value={progress}
          valueBuffer={buffer}
        />
      </div>
    </div>
  );
};

export default SplashPage;
